export class BannerView {
  constructor() {

  }
}
